import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Notice from "../pages/notice/page";
import Materials from "../pages/materials/page";
import Videos from "../pages/videos/page";
import Location from "../pages/location/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/notice",
    element: <Notice />,
  },
  {
    path: "/materials",
    element: <Materials />,
  },
  {
    path: "/videos",
    element: <Videos />,
  },
  {
    path: "/location",
    element: <Location />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
